export default __webpack_public_path__ + "static/media/ecom-cart.dfe9b7b4.gif";